import { create } from "zustand";
import { platform } from "@/platform";

/** 부팅 중 OTA 확인 대기 상한. 넘으면 이번 실행은 현재 번들로 부팅한다(다음 실행에서 다시 확인) */
const OTA_CHECK_TIMEOUT_MS = 3000;

/** OTA 진행률(0~100). null = 업데이트 없음(평소 스플래시). 스플래시는 null 여부만 본다(iOS 는 전송 중 진행률이 없다) */
export const useOtaProgress = create<{ percent: number | null }>(() => ({ percent: null }));

/**
 * 부팅 첫 단계(AC0-170). 새 번들이 있으면 스플래시에 진행률을 보이며 내려받고 바로 적용한다(웹뷰 다시 로드 → 이 함수는 돌아오지 않는다).
 * 내장 번들 복귀(서버가 번들을 껐을 때)도 즉시. 확인·내려받기 실패는 삼키고 현재 번들로 부팅을 이어 간다.
 */
export async function runOtaUpdate(): Promise<void> {
  const update = await platform.updater.check(OTA_CHECK_TIMEOUT_MS).catch(() => null);
  if (!update) return;
  try {
    if (update === "builtin") {
      await platform.updater.reset();
      return;
    }
    useOtaProgress.setState({ percent: 0 });
    await platform.updater.apply(update, (percent) => useOtaProgress.setState({ percent: Math.max(0, Math.min(100, Math.round(percent))) }));
  } catch {
    useOtaProgress.setState({ percent: null });
  }
}
